import { styled } from '@mui/material/styles';

export const Form = styled('form')(({ theme }) => ({
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.color.grey[500]}`,
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));
